'use strict'

angular.module('docketbook').
controller('trialBannerController', function(addressBookService, userService, uuid, $scope, $state, $window, $location, $stateParams, accessControl, $rootScope) {
    $scope.currentOrg = accessControl.currentOrg();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentUser = accessControl.currentUser();
    $scope.organisations = accessControl.allowedOrganisations();

    if ($scope.currentOrg && $scope.currentOrg.trial_end) {
        $scope.expiryDays = moment(new Date($scope.currentOrg.trial_end * 1000)).diff(new Date(), "days") + 1
        $scope.trialFinishedWithin1Week = $scope.expiryDays <= 0 && moment(new Date).diff(new Date($scope.currentOrg.trial_end * 1000), "days") <= 7
    }
})



// WEBPACK FOOTER //
// ./src/controllers/trialBannerController.js